var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('cart-bundles-wrap',{attrs:{"cart-article":_vm.cartArticleForMicro},on:{"delete-digital":_vm.deleteDigital,"delete-warranty":_vm.deleteWarranty,"delete-insurance":_vm.deleteInsurance,"delete-return-guarantee":_vm.deleteReturnGuarantee}})
}
var staticRenderFns = []

export { render, staticRenderFns }